import { init, push } from '@socialgouv/matomo-next'

let initialized = false

// Tenant ID and Site ID will be set / overwritten in the Openresty proxy
// See https://dvinci.atlassian.net/browse/ITADMIN-2900
export const initMatomo = (matomoPath: string) => {
  if (typeof window === 'undefined' || !matomoPath) return
  if (initialized) {
    return
  }

  init({
    url: getMatomoUrl(matomoPath),
    siteId: '1',
    disableCookies: true,
    onInitialization: () => {
      initialized = true
    }
  })
}

const getMatomoUrl = (matomoPath: string) => {
  return `https://${window.location.hostname}` + matomoPath
}

export const trackEvent = (eventName: string, eventValue: string) => {
  push(['trackEvent', eventName, eventValue])
}
